import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import ProdsTable from "./table-prods";
import { useState, useEffect, useMemo } from "react";
import { selectProducts } from "../../store/products/products.selector";

const ProductsPageSection = (props) => {
    const { selectedModel, handleOpen, handleChangeOnTbale } = props;

    const allProducts = useSelector(selectProducts);

    const modelProds = useMemo(() => {
        if (selectedModel === 'Todos') {
            return Object.values(allProducts || {}).flat();
        }
        return allProducts?.[selectedModel] || [];
    }, [selectedModel, allProducts]);

    const [formatProds, setFormatProds] = useState([]);

    useEffect(() => {
        if (modelProds) {
            const addId = modelProds.map((data, i) => ({
                ...data,
                id: i,
            }));
            console.log("addId: ", addId);
            setFormatProds(addId);
        }
    }, [modelProds]);

    return (
        <Box sx={{ width: "100%", height: "800px" }}>
            {formatProds.length > 0 && (
                <ProdsTable
                    data={formatProds}
                    handleOpen={handleOpen}
                    handleChangeOnTbale={handleChangeOnTbale}
                />
            )}
        </Box>
    );
};

export default ProductsPageSection;